import { Tab, TabList, TabPanel, Tabs } from "@mui/joy";
import React from "react";
import BuildingHeader from "../GenericComponents/BuildingHeader";
import ContactsListing from "./ContactsListing";
import ElevatorListing from "./ElevatorListing";
import InspectionReportsListing from "./InspectionReportsListing";
import NotesListing from "./NotesListing";
import TicketListing from "./TicketListing";
import ProposalInvoiceGrid from "./ProposalInvoiceGrid";
import { useRole, isAdminRole } from "../Contexts/RoleContext";

interface BuildingPageProps {
	BuildingID: string;
}

export default function BuildingPage(props: BuildingPageProps) {
	const { effectiveRole } = useRole();
	const isAdmin = isAdminRole(effectiveRole);

	return (
		<>
			<BuildingHeader buildingId={props.BuildingID} />
			<Tabs defaultValue="tickets" sx={{ overflowY: "hidden" }}>
				<TabList>
					<Tab value="tickets">Tickets</Tab>
					{isAdmin && (
						<>
							<Tab value="elevators">Elevators</Tab>
							<Tab value="notes">Notes</Tab>
							<Tab value="contacts">Contacts</Tab>
							<Tab value="inspection-reports">Inspection Reports</Tab>
						</>
					)}
					<Tab value="estimates">Estimates</Tab>
					<Tab value="invoices">Invoices</Tab>
				</TabList>
				<TabPanel sx={{ pt: 0, overflowY: "auto" }} value="tickets">
					<TicketListing buildingId={props.BuildingID} />
				</TabPanel>
				{isAdmin && (
					<>
						<TabPanel sx={{ p: 0, overflowY: "auto" }} value="elevators">
							<ElevatorListing buildingId={props.BuildingID} />
						</TabPanel>
						<TabPanel sx={{ p: 0, overflowY: "auto" }} value="notes">
							<NotesListing buildingId={props.BuildingID} />
						</TabPanel>
						<TabPanel sx={{ p: 0, overflowY: "auto" }} value="contacts">
							<ContactsListing buildingId={props.BuildingID} />
						</TabPanel>
						<TabPanel sx={{ p: 0, overflowY: "auto" }} value="inspection-reports">
							<InspectionReportsListing buildingId={props.BuildingID} />
						</TabPanel>
					</>
				)}
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value="estimates">
					<ProposalInvoiceGrid buildingId={props.BuildingID} isInvoice={false} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value="invoices">
					<ProposalInvoiceGrid buildingId={props.BuildingID} isInvoice={true} />
				</TabPanel>
			</Tabs>
		</>
	);
}
